import { restHeartClient } from '..'

/**
 * 获取文档对象。
 * @param db
 * @param collection
 * @param id
 */
export function getDocumentById(db: string, collection: string, id: string) {
	return restHeartClient.get(`${db}/${collection}/${id}`)
}
